export const employeeEs = {
  expense: `Gasto`,
  employee: `Empleado`,
  employee_management: `Gestión De Empleados`,
  add_employee: `Agregar empleado`,
  edit_employee: `Editar empleado`,
  cancel: `Cancelar`,
  save: `Guardar`,
  update: `Actualizar`,
  employee_updated_success: `Empleado actualizado correctamente`,
  employee_created_success: `Empleado creado correctamente`,
  delete_employee_dialog: `Eliminar empleado`,
  deleted_multiple: `{count} empleado(s) eliminado(s) correctamente`,
  delete_failed: `Error al eliminar {count} empleado(s)`,
  // Form labels
  select_user: `Seleccionar usuario`,
  user_email: `Correo electrónico del usuario`,
  user_cannot_be_changed: `El usuario no se puede cambiar`,
  employee_code: `Código`,
  first_name: `Nombre`,
  last_name: `Apellido`,
  department: `Departamento`,
  designation: `Designación`,
  gender: `Género`,
  employment_type: `Tipo`,
  address: `Dirección`,
  date_of_birth: `Fecha de nacimiento`,
  date_of_joining: `Fecha de ingreso`,
  added_by: `Agregado por`,

  // Gender options
  male: `Masculino`,
  female: `Femenino`,
  other: `Otro`,

  // Employment type options
  full_time: `Tiempo completo`,
  contract: `Contrato`,

  // Validation messages
  user_required: `Usuario es requerido`,
  user_notfound: `Usuario no encontrado`,
  user_not_active: `Usuario no está activo`,
  employeecode_required: `Código de empleado es requerido`,
  firstname_required: `Nombre es requerido`,
  lastname_required: `Apellido es requerido`,
  department_required: `Departamento es requerido`,
  designation_required: `Designación es requerida`,
  address_required: `Dirección es requerida`,
  employee_already_created: `Empleado ya existe para este usuario`,
  employeecode_already_exists: `El código de empleado ya existe`,
  employee_not_found: `Empleado no encontrado`,
  employee_already_deactive: `El empleado ya está desactivado`,
  successfully_deleted: `Successfully deleted`,
  select_gender: "Seleccionar género",
  select_employment_type: "Seleccionar tipo de empleo",

  // Other validation messages (for Yup schema)
  user_selection_required: `Selección de usuario es requerida`,
  invalid_employee_code: `El código de empleado solo puede contener letras y números`,
  firstname_min: `El nombre debe tener al menos 2 caracteres`,
  firstname_max: `El nombre no puede exceder 50 caracteres`,
  lastname_min: `El apellido debe tener al menos 2 caracteres`,
  lastname_max: `El apellido no puede exceder 50 caracteres`,
  department_min: `El departamento debe tener al menos 2 caracteres`,
  designation_min: `La designación debe tener al menos 2 caracteres`,
  invalid_gender: `Selección de género inválida`,
  invalid_employment_type: `Tipo de empleo inválido`,
  address_min: `La dirección debe tener al menos 5 caracteres`,
  something_went_wrong: `Algo salió mal`,
  error_fetching_employee_data: `Error al obtener datos del empleado`,
};
